
cms.core.init();